import { useCallback, useEffect, useState } from 'react';

import { useSnackbar } from 'notistack';

import { PromoConditionTypeConfig, PromoMeta, getPromoMeta } from '~/services/PromoService';

/**
 * usePromo is preferred for promo crud operations
 */
export default function usePromoMeta() {
  const { enqueueSnackbar } = useSnackbar();
  const [promoMeta, setPromoMeta] = useState<PromoMeta>(null);
  const [promoCodeConditionTypeConfig, setPromoCodeConditionTypeConfig] = useState<Array<PromoConditionTypeConfig>>([]);
  const [isPromoMetaLoading, setIsPromoMetaLoading] = useState(true);

  const fetchPromoMetaData = useCallback(async () => {
    setIsPromoMetaLoading(true);
    try {
      const response = await getPromoMeta();
      if (response.status === 200) {
        setPromoMeta(response.result);
        setPromoCodeConditionTypeConfig(response.result.promo_condition_types);
      } else {
        enqueueSnackbar(JSON.stringify(response) || 'Failed to fetch promo meta', { variant: 'error' });
      }
    } catch (err) {
      if ('errors' in err && err.errors?.length > 0) {
        err.errors.forEach((e) => {
          enqueueSnackbar(`Promo Meta Error: ${e.path} "${e.value}" ${e.message}`, {
            variant: 'error',
            autoHideDuration: 5000,
          });
        });
      } else {
        enqueueSnackbar(`Promo Meta Error: ${JSON.stringify(err)}`, { variant: 'error', autoHideDuration: 5000 });
      }
    } finally {
      setIsPromoMetaLoading(false);
    }
  }, [enqueueSnackbar]);

  useEffect(() => {
    if (promoMeta) {
      return;
    }
    fetchPromoMetaData();
  }, [fetchPromoMetaData]);

  return {
    promoMeta,
    promoCodeConditionTypeConfig,
    isPromoMetaLoading,
    fetchPromoMetaData,
  };
}
